import { request } from './http'
import type { CharacterStateView } from '@/types/nf'

const path = (projectId: string, branchId: string, mode?: 'history') => {
  const params = new URLSearchParams({ branch_id: branchId })
  if (mode === 'history') params.set('mode', mode)
  return `/v1/projects/${encodeURIComponent(projectId)}/characters/states?${params.toString()}`
}

export const characterStateApi = {
  list: (projectId: string, branchId: string): Promise<CharacterStateView[]> =>
    request<CharacterStateView[]>(path(projectId, branchId)),
  history: (projectId: string, branchId: string): Promise<CharacterStateView[]> =>
    request<CharacterStateView[]>(path(projectId, branchId, 'history')),
}
